import { UUID } from '@okcargo-apps/shared-domain';

export interface IMessageUi {
  id: UUID;
  objectId: string;
  message: string[];
  level: EMessageLevel;
  durationMs: number;
  type?: EMessageType;
  action?: {
    label: string;
    data: MessageActionType;
  };
}

export enum EMessageLevel {
  INFO,
  WARNING,
  ERROR,
}

export enum EMessageType {
  STOP_UPDATED_TYPE,
  STOP_UPDATED_UNLOADED_WEIGHT,
  STOP_UPDATED_UNLOADED_PACKAGES,
  STOP_WITHOUT_ADDRESS,
  STOPS_INVALID_DATES,
  STOPS_INVALID_UNLOADED_TOTAL_VALUES,

  STOP_MISSING_WEIGHT,
  STOP_MISSING_PACKAGES,
  STOP_INVALID_GOODS_DESCRIPTION,
  STOP_MISSING_UNLOADED_WEIGHT,
  STOP_MISSING_UNLOADED_PACKAGES,
  STOP_MISSING_UNTIL_DATE,
  STOP_MISSING_SINCE_DATE,
  STOP_SINCE_BEFORE_NOW,
  STOP_UNTIL_BEFORE_SINCE,

  STOP_ERRORS_GROUP,

  UNKNOWN,
  UNDEFINED,
}

export enum MessageActionType {
  VALIDATE_SHIPPER,
}

export const MESSAGE_DEFAULT_EXPIRATION_MS = 15_000; // 15 sec
